import React from 'react';
import { Modal } from 'react-bootstrap';

import { withTranslation } from 'react-i18next';
import CreateLocation from './CreateLocation';

class CreateLocationModal extends React.Component {
  render() {
    return (
      <Modal show={this.props.show} onHide={this.props.onHide}>
        <Modal.Header closeButton>
          <h4>{this.props.t('CREATE_LOCATION')}</h4>
        </Modal.Header>
        <Modal.Body>
          <CreateLocation
            onCreate={this.props.onCreate}
            onCreateLocationCancel={this.props.onHide}
            error={this.props.error}
            locationPending={this.props.locationPending}
          />
        </Modal.Body>
      </Modal>
    );
  }
}

export default withTranslation()(CreateLocationModal);
